// ABOUTME: Fixed-position alert for failed writes (reorder, column change, add).
// ABOUTME: Those used to be unhandled promise rejections with nothing on screen.

import React, { useEffect } from "react";

interface ErrorToastProps {
  message: string | null | undefined;
  onDismiss: () => void;
  /** Auto-dismiss after this many ms; 0 keeps it until dismissed. */
  autoHideMs?: number;
}

const ErrorToast: React.FC<ErrorToastProps> = ({ message, onDismiss, autoHideMs = 10000 }) => {
  useEffect(() => {
    if (!message || autoHideMs <= 0) return;
    const timer = setTimeout(onDismiss, autoHideMs);
    return () => clearTimeout(timer);
  }, [message, autoHideMs, onDismiss]);

  if (!message) return null;

  return (
    <div
      role="alert"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 max-w-md w-[calc(100%-2rem)]
                 flex items-start gap-3 px-4 py-3 rounded-[var(--radius-md)] shadow-lg
                 bg-[var(--color-bg-secondary)] border border-[color-mix(in_srgb,var(--color-danger)_40%,transparent)]
                 text-sm text-[var(--color-text-primary)]"
    >
      <span className="font-medium text-[var(--color-danger)] shrink-0">Couldn't save</span>
      <span className="min-w-0 flex-1 break-words">{message}</span>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        className="shrink-0 text-[var(--color-text-tertiary)] hover:text-[var(--color-text-primary)]"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
};

export default ErrorToast;
